import { SignInRPCClientImpl } from "@pulse/pulse-rpcs/lib/auth/signInRPCClientImpl";
import { APIClient } from "@surya-digital/tedwig";
import { MockSignInClientImpl } from "./MockSignInClientImpl";
import { MOCK } from "@pulse/shared-components";
import { SignInRPC } from "@pulse/pulse-rpcs/lib/auth/signInRPC";

export const useSignInRPCClientImpl = (apiClient: APIClient): SignInRPC => {
  if (MOCK.auth) {
    return new MockSignInClientImpl();
  } else {
    return new SignInRPCClientImpl(apiClient);
  }
};
